import React from 'react'

import { resizeY } from '../utils'

export const useDashboardHeight = (
    dashboardContext: LiveDashboardContextValue,
    mode: Mode,
    customHeight: number,
    widgetId: number,
    href: string
): void => {
    const risize = React.useCallback(() => {
        const layoutAlert = document.querySelector('#main-content .dashboard-main .layout-alert') as HTMLDivElement

        if (layoutAlert) {
            layoutAlert.setAttribute('style', 'display:none;')
        }

        if (dashboardContext && href.includes('mode=view')) {
            resizeY(dashboardContext, mode, widgetId, customHeight)
        }
    }, [widgetId, customHeight, href]) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        risize()
    }, [href]) // eslint-disable-line react-hooks/exhaustive-deps
}
